var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader",class:{ 'active': _setup.loading }},[_c('img',{attrs:{"src":"/img/loading/spinning-banana.gif","alt":"Loading..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }